import React, { Component } from "react";
import PropTypes from "prop-types";
import EditorBox from "../editor_box/EditorBox";
import EditorBoxSortable from "../editor_box_sortable/EditorBoxSortable";
import EditorShortcuts from "../editor_shortcuts/EditorShortcuts";
import { Col } from "react-bootstrap";
import EditorHeader from "../editor_header/EditorHeader";
import IdealStudio from "../../../../core/editor/main";
import { isSortableBox } from "../../../../common/utils";

export default class EditorCanvasDoc extends Component {
  render() {
    let titles = [];
    let itemSelected = this.props.fromCV
      ? this.props.containedViewSelected
      : this.props.navItemSelected;
    if (itemSelected.id !== 0) {
      let initialTitle = this.props.viewToolbars[itemSelected.id].viewName;
      titles.push(initialTitle);
      if (!this.props.fromCV) {
        let parent = itemSelected.parent;
        while (parent !== 0) {
          titles.push(this.props.viewToolbars[parent].viewName);
          parent = this.props.navItems[parent].parent;
        }
      }
      titles.reverse();
    }

    let maincontent = document.getElementById(
      this.props.fromCV ? "contained_maincontent" : "maincontent"
    );
    let actualHeight;
    if (maincontent) {
      actualHeight = parseInt(maincontent.scrollHeight, 10);
      actualHeight =
        parseInt(maincontent.clientHeight, 10) < actualHeight ? actualHeight + "px" : "100%";
    }

    let overlayHeight = actualHeight ? actualHeight : "100%";
    let boxes = itemSelected ? itemSelected.boxes : [];
    let show = itemSelected && itemSelected.id !== 0;

    let commonProps = { ...this.props, pageType: itemSelected.type || 0 };

    let toolbar = this.props.viewToolbars[itemSelected.id];
    return (
      <Col
        id={this.props.fromCV ? "containedCanvas" : "canvas"}
        md={12}
        xs={12}
        className="canvasDocClass"
        style={{
          display:
            this.props.containedViewSelected !== 0 && !this.props.fromCV ? "none" : "initial",
        }}
      >
        <div
          className="scrollcontainer parentRestrict"
          style={{
            backgroundColor: show ? toolbar.background : "transparent",
            display: show ? "block" : "none",
          }}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              this.props.onBoxSelected(-1);
              this.setState({ showTitle: false });
            }
            e.stopPropagation();
          }}
        >
          {/* {this.props.boxSelected} - ({(this.props.boxSelected && this.props.boxes[this.props.boxSelected]) ? this.props.boxes[this.props.boxSelected].level : '-'}) - {this.props.boxLevelSelected} */}
          {/* Canvas-level scene header removed — see EditorCanvasSli for rationale. */}
          <div className="outter canvaseditor" style={{ display: show ? "block" : "none" }}>
            <div
              id={this.props.fromCV ? "airlayer_cv" : "airlayer"}
              className={(this.props.fromCV ? "airlayer_cv" : "airlayer") + " doc_air"}
              style={{ visibility: show ? "visible" : "hidden" }}
            >
              <div
                id={this.props.fromCV ? "contained_maincontent" : "maincontent"}
                className={"innercanvas doc"}
                style={{ visibility: show ? "visible" : "hidden", paddingBottom: "10px" }}
              >
                <br />

                {boxes.map((id) => {
                  if (!isSortableBox(id)) {
                    // Floating boxes (e.g. full-screen overlay plugins such as
                    // GuideMultiInput) are rendered as an absolute layer over
                    // the scene instead of flowing in the document.
                    return (
                      <EditorBox
                        key={id}
                        id={id}
                        {...commonProps}
                        page={itemSelected ? itemSelected.id : 0}
                        exercises={
                          itemSelected
                            ? this.props.exercises?.[itemSelected.id]?.exercises?.[id]
                            : undefined
                        }
                      />
                    );
                  }
                  return (
                    <EditorBoxSortable
                      key={id}
                      {...commonProps}
                      id={id}
                      exercises={this.props.exercises}
                      page={itemSelected ? itemSelected.id : 0}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <EditorShortcuts
          store={this.props.store}
          openConfigModal={this.props.openConfigModal}
          box={this.props.boxes[this.props.boxSelected]}
          containedViewSelected={this.props.containedViewSelected}
          isContained={this.props.fromCV}
          onTextEditorToggled={this.props.onTextEditorToggled}
          onBoxResized={this.props.onBoxResized}
          onBoxDeleted={this.props.onBoxDeleted}
          onToolbarUpdated={this.props.onToolbarUpdated}
          onAddNewAnimation={this.props.onAddNewAnimation}
          onBoxStartAnimation={this.props.onBoxStartAnimation}
          onBoxMiddleAnimation={this.props.onBoxMiddleAnimation}
          onBoxEndAnimation={this.props.onBoxEndAnimation}
          navItemSelected={this.props.navItemSelected}
          fileModalResult={this.props.fileModalResult}
          openFileModal={this.props.openFileModal}
          lastActionDispatched={this.props.lastActionDispatched}
          pointerEventsCallback={
            this.props.pluginToolbars[this.props.boxSelected] &&
            this.props.pluginToolbars[this.props.boxSelected].config &&
            this.props.pluginToolbars[this.props.boxSelected].config.name &&
            IdealStudio.Plugins.get(this.props.pluginToolbars[this.props.boxSelected].config.name)
              ? IdealStudio.Plugins.get(
                  this.props.pluginToolbars[this.props.boxSelected].config.name
                ).pointerEventsCallback
              : null
          }
          onMarkCreatorToggled={this.props.onMarkCreatorToggled}
          pluginToolbar={this.props.pluginToolbars[this.props.boxSelected]}
          uploadFunction={this.props.uploadFunction}
          base={this.props.base}
        />
      </Col>
    );
  }
}

EditorCanvasDoc.propTypes = {
  /**
   * Check if component is rendered from contained view
   */
  fromCV: PropTypes.bool,
  /**
   * Object containing all created boxes (by id)
   */
  boxes: PropTypes.object.isRequired,
  /**
   * Current Box selected. If there isn't, -1
   */
  boxSelected: PropTypes.any.isRequired,
  /**
   * Selected box level (only plugins inside plugins)
   */
  boxLevelSelected: PropTypes.number.isRequired,
  /**
   * Object containing all views (by id)
   */
  navItems: PropTypes.object.isRequired,
  /**
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Selected contained view (by ID)
   */
  containedViewSelected: PropTypes.any.isRequired,
  /**
   * Course title
   */
  title: PropTypes.string.isRequired,
  /**
   * Object containing every view toolbar (by id)
   */
  viewToolbars: PropTypes.object.isRequired,
  /**
   * Object containing every plugin toolbar (by id)
   */
  pluginToolbars: PropTypes.object.isRequired,
  /**
   * Last action dispatched in Redux
   */
  lastActionDispatched: PropTypes.any.isRequired,
  /**
   * Callback for adding a mark shortcut
   */
  addMarkShortcut: PropTypes.func.isRequired,
  /**
   * Callback for deleting mark creator overlay
   */
  deleteMarkCreator: PropTypes.func.isRequired,
  /**
   * Identifier of the box that is creating a mark
   */
  markCreatorId: PropTypes.any.isRequired,
  /**
   * Object containing box marks
   */
  marks: PropTypes.object,
  /**
   * Callback for toggling creation mark overlay
   */
  onMarkCreatorToggled: PropTypes.func.isRequired,
  /**
   * Callback for adding a box
   */
  onBoxAdded: PropTypes.func.isRequired,
  /**
   * Callback for deleting a box
   */
  onBoxDeleted: PropTypes.func.isRequired,
  /**
   * Callback for selecting a box
   */
  onBoxSelected: PropTypes.func.isRequired,
  /**
   * Callback for increasing box level selected (only plugins inside plugins)
   */
  onBoxLevelIncreased: PropTypes.func.isRequired,
  /**
   * Callback for moving a box
   */
  onBoxMoved: PropTypes.func.isRequired,
  /**
   * Callback for resizing a box
   */
  onBoxResized: PropTypes.func.isRequired,
  /**
   * Callback for dropping a box
   */
  onBoxDropped: PropTypes.func.isRequired,
  /**
   * Callback for vertically aligning boxes inside a container
   */
  onVerticallyAlignBox: PropTypes.func.isRequired,
  /**
   * Callback for reordering boxes inside a container
   */
  onBoxesInsideSortableReorder: PropTypes.func.isRequired,
  /**
   * Callback for deleting a sortable container
   */
  onSortableContainerDeleted: PropTypes.func.isRequired,
  /**
   * Callback for reordering sortable containers
   */
  onSortableContainerReordered: PropTypes.func.isRequired,
  /**
   * Callback for resizing a sortable container
   */
  onSortableContainerResized: PropTypes.func.isRequired,
  /**
   * Callback for toggling CKEditor
   */
  onTextEditorToggled: PropTypes.func.isRequired,
  /**
   * Callback for toggling rich marks modal creator
   */
  onRichMarksModalToggled: PropTypes.func.isRequired,
  /**
   * Callback for moving marks
   */
  onRichMarkMoved: PropTypes.func.isRequired,
  /**
   * Callback for modify navitem title and subtitle
   */
  onViewTitleChanged: PropTypes.func.isRequired,
  /**
   * Callback for modify course title
   */
  onTitleChanged: PropTypes.func.isRequired,
  /**
   * Object containing all exercises
   */
  exercises: PropTypes.object,
  /**
   * Callback for opening global configuration modal
   */
  openConfigModal: PropTypes.func,
  /**
   * Callback for setting the right answer of an exercise
   */
  setCorrectAnswer: PropTypes.func.isRequired,
  /**
   * Callback for updating view toolbar
   */
  onToolbarUpdated: PropTypes.func,
  /**
   * Last files uploaded to server or searched in modal
   */
  fileModalResult: PropTypes.object,
  /**
   * Function that opens the file search modal
   */
  openFileModal: PropTypes.func.isRequired,
  /**
   * Function for uploading files
   */
  uploadFunction: PropTypes.func,
};
